import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCookieConsent, setCookieConsent } from "@/lib/tracking";

const COOKIE_POPUP_DELAY_MS = 600;

/* Global cookie consent banner — appears on any page if the user has not yet
   made a choice. Persists in localStorage; never reappears after a decision. */
export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const existing = getCookieConsent();
    if (!existing) {
      const t = setTimeout(() => setShow(true), COOKIE_POPUP_DELAY_MS);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    setCookieConsent(value);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="cookie-consent"
      role="dialog"
      aria-live="polite"
      className="fixed bottom-3 left-3 right-3 sm:bottom-4 sm:left-auto sm:right-4 sm:max-w-sm z-[70] slide-up-in"
    >
      <div className="rounded-2xl bg-white border border-black/10 shadow-[0_20px_50px_-18px_rgba(0,0,0,0.35)] p-4 sm:p-5">
        <p className="text-[12.5px] sm:text-[13px] leading-relaxed text-black/75">
          Acest website utilizează cookie-uri pentru analiză și îmbunătățirea
          experienței utilizatorilor.{" "}
          <Link
            to="/gdpr-cookies"
            data-testid="cookie-consent-link"
            className="font-semibold underline decoration-black/30 hover:decoration-black underline-offset-2 text-black"
          >
            Află mai mult
          </Link>
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => decide("all")}
            data-testid="cookie-accept"
            className="inline-flex items-center justify-center px-4 py-2 rounded-full bg-black text-white text-[12px] font-bold hover:bg-black/85 transition"
          >
            Acceptă
          </button>
          <button
            type="button"
            onClick={() => decide("partial")}
            data-testid="cookie-accept-partial"
            className="inline-flex items-center justify-center px-4 py-2 rounded-full bg-white text-black text-[12px] font-bold border border-black/15 hover:bg-black/[0.04] transition"
          >
            Acceptă parțial
          </button>
          <button
            type="button"
            onClick={() => decide("none")}
            data-testid="cookie-refuse"
            className="inline-flex items-center justify-center px-3 py-2 text-[12px] font-semibold text-black/55 hover:text-black transition"
          >
            Refuză
          </button>
        </div>
      </div>
    </div>
  );
}
